import { sendWebsocketMessage } from '../../../../../../App';

export function userTrade(tradePlanId, orderType, qty, tradeType, limit, sym) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'userTrade',
    value: {
      orderType,
      qty,
      tradeType,
      limit,
      symbol: sym
    }
  };
  sendWebsocketMessage(msg);
}
